export default "__VITE_ASSET__Dnz3wlbp__"